import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { PhotoService } from '../services/photo.service';
import { smokingProtocol } from '../models/smoking_protokol';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { StopwatchService } from '../services/stopwatch.service';
import { ModalController, Platform, PopoverController, ToastController } from '@ionic/angular';
import { Drink } from '../models/drink';
import { HumidorEntry } from '../models/humidor_entry';
import { Aroma } from '../models/aroma';
import { SmokingprotocolService } from '../services/smokingprotocol.service';
import { DisplayloadingService } from '../services/displayloading.service';
import { YesNoPopupComponent } from '../popovers/yes-no-popup/yes-no-popup.component';
import { TranslateService } from '@ngx-translate/core';
import { LocalNotificationsService } from '../services/local-notifications.service';
import { Subscription } from 'rxjs';
import { ConfigService } from '../services/config.service';
import { AuthService } from '../services/auth.service';
import { StatisticsService } from '../services/statistics.service';


@Component({
  selector: 'app-rauchprotokoll',
  templateUrl: './rauchprotokoll.component.html',
  styleUrls: ['./rauchprotokoll.component.scss'],
})
export class RauchprotokollComponent implements OnInit, OnDestroy {

  @Input() entry: HumidorEntry;

  private activeStep: number; /*schrittweises Vorgehen:
  1. optionales Photo
  2. Location setzen
  3. Anschnitt
  4. Begutachtung Erscheinungsbild
  5. Getränk
  6. Anzünden
  7. Aromen registrieren
  8. Übersicht und Zigarre bewerten
  */

  public smokingProtocol: smokingProtocol;
  public wrapperForm: UntypedFormGroup;
  public finalRatingForm: UntypedFormGroup;
  public drinks: Drink[];//step 5 Drink Selection
  public aromas: Aroma[];//step 7 Aroma Recognization
  private pauseSub: Subscription = null; //Subscription auf das Pause-Event -> zeigt LN an
  private resumeSub: Subscription = null;
  private drinkSub: Subscription = null;
  private aromaSub: Subscription = null;
  public currency: string;
  public showRecom: boolean = false;

  constructor(private photoService: PhotoService,
    public ss: StopwatchService, private mc: ModalController, private fb: UntypedFormBuilder,
    private sps: SmokingprotocolService, private popc: PopoverController,
    private toast: ToastController, private ls: DisplayloadingService,
    private platform: Platform, private translate: TranslateService, private authS: AuthService,
    private statS: StatisticsService,
    private lns: LocalNotificationsService, private cfs: ConfigService) {

  }


  async ngOnInit() {

    //Wenn bereits ein Protokoll im SessionStorage liegt immer fortsetzen
    if (localStorage.getItem("smokingProtocol") !== null) {
      this.smokingProtocol = JSON.parse(localStorage.getItem("smokingProtocol"));
      this.setactiveStep(this.smokingProtocol.activeStep);
    }
    else {
      if (typeof this.activeStep === "undefined") {
        this.activeStep = 1;
      }
      this.smokingProtocol = new smokingProtocol(this.entry, this.activeStep);

    }
    //Bewertung Deckblatt
    this.wrapperForm = this.fb.group({

      wrapper_color: this.smokingProtocol.cigarWrapper.color,
      wrapper_structure: this.smokingProtocol.cigarWrapper.structure,
      wrapper_comments: this.smokingProtocol.cigarWrapper.comments,
      wrapper_rating: this.smokingProtocol.cigarWrapper.rating

    });
    //Bewertung komplett Step 8
    let entryCigarStrength = 0;
    if (typeof (this.entry) !== "undefined") {
      entryCigarStrength = this.entry.cigarStrength;
      if (entryCigarStrength === 0) {
        entryCigarStrength = 1;
      }
    }
    this.finalRatingForm = this.fb.group({
      cigar_draw: this.smokingProtocol.cigarDrawRating,
      cigar_burn: this.smokingProtocol.cigarBurnRating,
      cigar_ashes: this.smokingProtocol.cigarAshesRating,
      cigar_taste: this.smokingProtocol.cigarTasteRating,
      cigar_strength: entryCigarStrength,
      conclusion: this.smokingProtocol.conclusion,
      beverage_fits: "0"
    });


    /*Benutzer kommt zurück in App und ist auf
    Step 7 (Rauchvorgang läuft)
    => Rauchvorgang erneut starten (Timer bleibt sonst stehen)
    */
    this.resumeSub = this.platform.resume.subscribe(() => {
      if (this.getactiveStep() === 7) {
        this.startSmoking();
      }
    });
    /*Benutzer verlässt App und ist auf Step 7
    => Local Notification anzeigen
    */
    this.pauseSub = this.platform.pause.subscribe(async () => {
      if (this.getactiveStep() === 7) {
        let formattedDate = new Date(this.smokingProtocol.startedSmokingAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        //console.log(formattedDate);
        this.translate.get("smoking-protocol.smoking-process-runs").subscribe((translation) => {
          const lnMessage = `${translation} ${formattedDate}`;
          this.lns.generateLN(lnMessage, 'Cigaro');
        });
      }
    });
    //PWA
    if (this.platform.is("pwa") || this.platform.is("mobileweb") || this.platform.is("desktop")) {
      document.addEventListener("visibilitychange", () => {
        if (this.getactiveStep() === 7) {
          this.startSmoking();
          /*
          let formattedDate = new Date(this.smokingProtocol.startedSmokingAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
          //console.log(formattedDate);
          this.translate.get("smoking-protocol.smoking-process-runs").subscribe((translation) => {
            const lnMessage = `${translation} ${formattedDate}`;
            this.lns.generateLN(lnMessage, 'Cigaro');
          });*/
        }
      }, false);
    }
    this.currency = this.cfs.getCurrency();
  }




  /**
   * @description
   * Addition Komplettbewertung
   */
  public calculateRating() {
    this.smokingProtocol.cigarWrapper.rating = this.wrapperForm.value.wrapper_rating;
    this.smokingProtocol.cigarDrawRating = this.finalRatingForm.value.cigar_draw;
    this.smokingProtocol.cigarBurnRating = this.finalRatingForm.value.cigar_burn;
    this.smokingProtocol.cigarAshesRating = this.finalRatingForm.value.cigar_ashes;
    this.smokingProtocol.cigarTasteRating = this.finalRatingForm.value.cigar_taste;
    this.smokingProtocol.ratingComplete = this.smokingProtocol.cigarWrapper.rating +
      this.smokingProtocol.cigarTasteRating + this.smokingProtocol.cigarBurnRating +
      this.smokingProtocol.cigarDrawRating + this.smokingProtocol.cigarAshesRating;
  }
  /**
   * @param stepnr
   * @returns boolean
   * @description
   * Stufenweise Dokumentation
   * Aktiviert die jeweilige Stufe des Rauchvorgangs
   */
  async setactiveStep(stepnr: number): Promise<boolean> {
    console.log(this.smokingProtocol);
    this.activeStep = stepnr;
    switch (stepnr) {
      case 5:
        this.drinkSub = this.sps.getAllDrinksInclRecom(this.smokingProtocol.humEntry.cigar.id).subscribe((drinks: Drink[]) => {
          this.drinks = drinks;
          for (let i = 0; i < this.drinks.length; i++) {
            if (typeof (this.drinks[i]) !== 'undefined' && this.drinks[i].matches == true) {
              this.showRecom = true;
              break;
            }
          }
        });

        break;
      case 7:
        this.startSmoking();
        this.aromaSub = this.sps.getAllAromas().subscribe((aromas: Aroma[]) => {
          this.aromas = aromas;
          //console.log(this.aromas);
        });
        break;
      case 8:
        await this.continueSmoking();
        this.smokingProtocol.smokingTime = await this.ss.getMinutes();//Rauchzeit ermitteln
        await this.stopSmoking();//Timer stoppen
        break;
    }
    this.smokingProtocol.activeStep = stepnr;
    localStorage.setItem("smokingProtocol", JSON.stringify(this.smokingProtocol));
    return true;
  }

  /**
   *
   * @returns aktive Stufe
   */
  getactiveStep() {
    //console.log(this.smokingProtocol)
    return this.activeStep;
  }
  /**
   * @param where indoor oder outdoor
   * @description
   * Wo wird Zigarre geraucht? Step2
   */
  setLocation(where: string) {

    this.smokingProtocol.smokingLocation = where;
    this.setactiveStep(3);
  }
  /**
   * @param how double, drill, v-cut, scissors, none
   * @description
   * Wie wurde Zigarre angeschnitten? Step3
   */
  setCut(how: string) {
    this.smokingProtocol.cut = how;
    this.setactiveStep(4);
  }
  /**
   * @description
   * Absenden Form Deckblatt-Bewertung
   * Step 4
   */
  submitWrapper() {
    if (this.wrapperForm.valid === true) {
      this.smokingProtocol.cigarWrapper.color = this.wrapperForm.value.wrapper_color;
      this.smokingProtocol.cigarWrapper.structure = this.wrapperForm.value.wrapper_structure;
      this.smokingProtocol.cigarWrapper.comments = this.wrapperForm.value.wrapper_comments;
      this.smokingProtocol.cigarWrapper.rating = this.wrapperForm.value.wrapper_rating;
      this.setactiveStep(5);
    }

  }
  /**
   * @param drink
   * @description
   * Getränk registrieren
   * Step 5
   */
  setBeverage(drink: Drink) {
    this.smokingProtocol.beverage = drink;
    this.setactiveStep(6);
  }
  /**
   * @param aroma:Aroma
   * @description
   * Aroma registrieren
   * Step 7
   */
  async addAroma(aroma: Aroma) {
    let aromaToAdd: Aroma = {
      id: aroma.id,
      identifier: aroma.identifier,
      minute: this.ss.getMinutes(),
      intensity: 2
    };
    //nur registrieren, wenn Rauchvorgang läuft
    if (this.smokingProtocol.status === "running") {
      console.log(this.smokingProtocol);
      //Zunächst überprüfen, ob das gleiche Aroma schon in den letzten fünf Minuten registriert wurde
      let aromaHot: boolean = false; //ist das Aroma noch heiß?
      let aromaToCheckFor: Aroma = {
        id: aroma.id,
        identifier: aromaToAdd.identifier,
        minute: this.ss.getMinutes(),
        intensity: 2
      };
      for (let i: number = 0; i < 10; i++) {
        if (aromaToCheckFor.minute >= 0) {
          console.log("Es wird verglichen mit...");
          console.log(aromaToCheckFor);
          for (let j: number = 0; j < this.smokingProtocol.taste.length; j++) {
            if (this.smokingProtocol.taste[j].identifier === aromaToCheckFor.identifier && this.smokingProtocol.taste[j].minute === aromaToCheckFor.minute) {
              aromaHot = true;
              break;
            }
          }
          aromaToCheckFor.minute--;
        }
        else {
          break;
        }
      }
      if (aromaHot === true) {
        //Nachricht ausgeben, dass Aroma bereits innerhalb 10 registriert wurde
        let aromaMessage: string = this.translate.instant("smoking-protocol.aroma-lastfive");
        const toast = await this.toast.create({
          message: aromaMessage,
          duration: 2000,
          position: 'top'
        });
        toast.present();
      }
      //Aroma innerhalb der letzten zehn Minuten nicht registriert
      else {
        let found = false;
        let foundCount: number = 0;
        //Überprüfen, wie oft schon registriert wurde
        this.smokingProtocol.taste.forEach((sAroma) => {
          if (sAroma.identifier === aromaToAdd.identifier) {
            foundCount++;
            if (foundCount > 2) {
              found = true;
            }
          }
        });
        //Weniger als 3mal registriert -> Aroma hinzufügen
        if (found === false) {
          this.smokingProtocol.taste.push(aromaToAdd);
          localStorage.setItem("smokingProtocol", JSON.stringify(this.smokingProtocol));
          //Nachricht ausgeben, dass Aroma registriert wurde
          let regMessage: string = this.translate.instant("smoking-protocol.aroma-registered_1") + (foundCount + 1).toString() + "x, " + (2 - foundCount).toString() +
            this.translate.instant("smoking-protocol.aroma-registered_2");
          const toast = await this.toast.create({
            message: regMessage,
            duration: 2000,
            position: 'top'
          });
          toast.present();
        }
      }
    }
    //SP wurde gestoppt/pausiert
    else {
      let spRunningMessage = this.translate.instant("smoking-protocol.aroma-onlywhilerunning");
      const toast = await this.toast.create({
        message: spRunningMessage,
        duration: 2000,
        position: 'top'
      });
      toast.present();
    }
  }
  /**
   *
   * @param aroma:Aroma
   * @description
   * Pro Rauchvorgang wird ein bestimmtes Aroma nur drei mal registriert
   * Step 7
   * @returns true, wenn Aroma bereits drei mal registriert wurde
   */
  aromaAdded(aroma: Aroma): boolean {
    let found = false;
    let foundCount: number = 0;
    this.smokingProtocol.taste.forEach((sAroma) => {
      if (sAroma.identifier === aroma.identifier) {
        foundCount++;
        if (foundCount > 2) {
          found = true;
        }
      }
    });
    return found;
  }
  /**
   * @description
   * Gewichtung der einzelnen Aromen auf dem letzten Step
   * @param aroma 
   */
  weightAroma(aroma: Aroma, rangeEvent: any) {
    console.log(aroma);
    aroma.intensity = rangeEvent.detail.value;
  }

  /**
   * @param type
   * @description
   * Bestimmte Fehler, die beim Rauchen auftreten k önnen, registrieren
   * Schiefbrand, Tunnelbrand, Ausgehen
   * Es soll nur ein bestimmter Alarm pro Minute registriert werden können
   * Step 7
   */
  async spAlert(type: string) {
    let minute: number = this.ss.getMinutes() + 1;
    let smokeAlert = { type: type, time: minute };
    let exists = false;
    this.smokingProtocol.alerts.forEach((smalert) => {
      if (JSON.stringify(smalert) === JSON.stringify(smokeAlert)) {
        exists = true;
      }
    });
    if (exists === false) {
      if (this.smokingProtocol.alerts.length < 10) {
        this.smokingProtocol.alerts.push(smokeAlert);
        localStorage.setItem("smokingProtocol", JSON.stringify(this.smokingProtocol));
        const toast = await this.toast.create({
          message: this.translate.instant("alerts.registered") + minute,
          duration: 2000,
          position: 'top'
        });
        toast.present();
      }
      else {
        const toast = await this.toast.create({
          message: this.translate.instant("alerts.toomuch"),
          duration: 2000,
          position: 'top'
        });
        toast.present();
      }
    }
    else {
      const toast = await this.toast.create({
        message: this.translate.instant("alerts.already"),
        duration: 2000,
        position: 'top'
      });
      toast.present();
    }
  }
  /**
   * @description
   * Nimmt (wenn gewünscht) Bild der Zigarre über Capacitor-Plugin auf
   * Step 1
   */
  async addPhotoToGallery() {
    await this.ls.presentLoading();
    this.smokingProtocol.photo = await this.photoService.takePhoto();
    await this.ls.hideLoading();
    this.setactiveStep(2);
  }
  /**
   * @description
   * Rauchvorgang und somit Stoppuhr starten
   * Step 7
   */
  public startSmoking() {
    if (this.smokingProtocol.status !== "paused") {
      //Erstmaliger Start
      if (this.smokingProtocol.startedSmokingAt === null) {
        this.smokingProtocol.startedSmokingAt = Date.now();
        this.ss.start({ minutes: 0, seconds: 0 });
      }
      //Fortsetzung, Rückkehr aus Ruhemodus, etc.
      else {
        const actualTime = Date.now();
        var diff = actualTime - this.smokingProtocol.startedSmokingAt;
        let secondsDiff = Math.round(diff / 1000);
        if (this.smokingProtocol.pausedTime !== null) {
          secondsDiff -= this.smokingProtocol.pausedTime;
        }
        //console.log(`seconds passed: ${secondsDiff}`);
        const minutes = Math.floor(secondsDiff / 60);
        const seconds = (secondsDiff % 60);
        this.ss.start({ minutes: minutes, seconds: seconds });
      }
      this.smokingProtocol.status = "running";
    }
    localStorage.setItem("smokingProtocol", JSON.stringify(this.smokingProtocol));
  }
  /**
   * @description
   * vom Nutzer angehaltenen Rauchvorgang fortsetzen
   */
  public continueSmoking() {
    if (this.smokingProtocol.status === "paused" && this.smokingProtocol.pausedAt !== null) {
      const continuedAt = Date.now();
      this.smokingProtocol.pausedTime += Math.round((continuedAt - this.smokingProtocol.pausedAt) / 1000);
      this.smokingProtocol.status = "running";
      this.smokingProtocol.pausedAt = null;
    }
    this.startSmoking();
  }

  /**
   * @description
   * Rauchvorgang und somit Stoppuhr stoppen
   */
  public async stopSmoking() {
    this.ss.stop(); //Stopuhr anhalten
    //ggf. LocalNotification löschen
    await this.lns.deleteLN_All();
    //Timer speichern
    const minutes = this.ss.getMinutes();
    const seconds = this.ss.getSeconds()
    this.smokingProtocol.status = "paused";
    this.smokingProtocol.pausedAt = Date.now();
    localStorage.setItem("smokingProtocol", JSON.stringify(this.smokingProtocol));
  }
  /**
   * One Step back
   */
  public getBack() {
    this.setactiveStep(this.activeStep - 1);
  }

  public async closeProtocol() {
    //Soll das Rauchprotokoll gelöscht werden
    const ynpDeleteSP = await this.popc.create({
      component: YesNoPopupComponent,
      componentProps: {
        questionType: "delete-sp"
      }
    });
    await ynpDeleteSP.present();
    const answer = await ynpDeleteSP.onDidDismiss();
    //Wenn Ja und bereits im LocalStorage --> entfernen
    if (typeof (answer.data) !== "undefined" && answer.data.answer === true) {
      this.stopSmoking();
      if (localStorage.getItem("smokingProtocol") !== null) {
        localStorage.removeItem("smokingProtocol");
      }
      this.mc.dismiss({
        spStatus: "cancelled"
      });
    }
    else {
      //Falls nein LocalStorage-Object aktualisieren
      localStorage.setItem("smokingProtocol", JSON.stringify(this.smokingProtocol));
      this.mc.dismiss({
        spStatus: "running"
      });
    }
  }

  /**
   * @description
   * Die finale Bewertung der Zigarre wird ermittelt
   * und das Protokoll in der Datenbank gespeichert
   */
  async submitFinalRatingForm() {
    // idiots hitting button up to 10 times
    document.querySelector("#submitProt").setAttribute("disabled", "disabled");
    await this.ls.presentLoading();
    if (this.finalRatingForm.valid === true) {
      this.calculateRating();//holt alle Rating-Parameter
      this.smokingProtocol.cigarStrengthRating = this.finalRatingForm.value.cigar_strength;
      this.smokingProtocol.beverage_fitted = this.finalRatingForm.value.beverage_fits;
      this.smokingProtocol.conclusion = this.finalRatingForm.value.conclusion;
      //Der Service speichert und gibt Daten als Observable zurück
      this.sps.saveProtocol(this.smokingProtocol).subscribe(async (data) => {
        await this.ls.hideLoading();
        const user = this.authS.getCigaroUser();
        //Tracken, wenn History aktiviert
        if (user.humidor_view.show_archive == true) {
          this.statS.addToHistory(this.smokingProtocol.humEntry.cigar.id, this.smokingProtocol.humEntry.pricePerCigar);
        }
        const sp_saved = this.translate.instant("smoking-protocol.sp_saved");
        let toastMessage = sp_saved;
        if (data.changes[0] === true) {
          const strength_changed = this.translate.instant("smoking-protocol.strength_changed");
          toastMessage += "\n" + strength_changed;
        }
        if (data.changes[1] === true) {
          const time_changed = this.translate.instant("smoking-protocol.time_changed");
          toastMessage += "\n" + time_changed;
        }
        if (data.changes[2] === true) {
          const tastes_changed = this.translate.instant("smoking-protocol.tastes_changed");
          toastMessage += "\n" + tastes_changed;
        }
        if (data.changes[3] === true) {
          const drinks_changed = this.translate.instant("smoking-protocol.drinks_changed");
          toastMessage += "\n" + drinks_changed;
        }
        //Präsentation für Nutzer
        const toast = await this.toast.create({
          message: toastMessage,
          duration: 3000,
          position: 'top',
          id: 'spfinishToast'
        });
        await toast.present();
        toast.onDidDismiss().then(() => {
          localStorage.removeItem("smokingProtocol");
          if (typeof (data.changedHumEntry) !== "undefined") {
            this.mc.dismiss({
              humentryChanged: data.changedHumEntry,
              spStatus: "finished"
            });
          }
          else {
            this.mc.dismiss({
              spStatus: "finished"
            });
          }
        });
      });
    }
    else {
      await this.ls.hideLoading();
    }
    //console.log(this.smokingProtocol)
  }
  /**
   * @description
   * Aroma aus Rauchprotokoll auf Übersichtsseite entfernen
   * @param index (Index im Aroma-Array am SP)
   */
  async removeAroma(index: number) {
    const delAromaPop = await this.popc.create({
      component: YesNoPopupComponent,
      componentProps: { questionType: 'delete-aroma-from-sp' }
    });
    await delAromaPop.present();
    const data = await delAromaPop.onDidDismiss();
    console.log(data)
    if (data.data.answer === true) {
      this.smokingProtocol.taste.splice(index, 1);
    }
  }

  /**
   *
   * @param url Tatsächlicher Ort des Bildes
   * @returns anzeigbare Bild-Url
   */
  getPhotoUrl(url: string): string {
    return this.photoService.getRealPhotoPath(url);
  }

  /**
   * 
   * @returns Rauchzeit in Minuten pro Euro/Dollar, etc.
   */
  rauchProGeld(): number {
    if (this.smokingProtocol.smokingTime !== 0) {
      let rpg: number = (this.smokingProtocol.smokingTime / this.smokingProtocol.humEntry.pricePerCigar) * 100;
      rpg = parseFloat((Math.round(rpg) / 100).toFixed(2));
      this.smokingProtocol.rpg = rpg;
      return rpg;
    }
    else {
      return 0;
    }
  }



  ngOnDestroy() {
    if (this.pauseSub !== null) {
      this.pauseSub.unsubscribe();
    }
    if (this.resumeSub !== null) {
      this.resumeSub.unsubscribe();
    }
    if (this.drinkSub !== null) {
      this.drinkSub.unsubscribe();
    }
    if (this.aromaSub !== null) {
      this.aromaSub.unsubscribe();
    }
  }
}
